import { DateStringSchema, type ZodSimplify } from '@mntn-dev/utility-types'
import { z } from 'zod'
import { BillingServiceIdSchema } from '../billing-profile.models.ts'
import { ChargeProductTypeSchema } from './charge-product-type.ts'
import { ChargeStatusSchema } from './charge-status.ts'
import { InvoicePaymentTermsSchema } from './invoice-payment-terms.ts'
import { MntnCustomerIdSchema } from './mntn-customer-id.ts'
import { UnitSchema } from './unit.ts'

export const ChargeLineItemSchema = z.discriminatedUnion('billingMethod', [
  // Invoice billing method
  z.object({
    createdTime: DateStringSchema,
    updatedTime: DateStringSchema.optional(),
    billingMethod: z.literal('invoice'),
    invoicePaymentTerms: InvoicePaymentTermsSchema,
    unit: UnitSchema,
    amount: z.number(),
    productType: ChargeProductTypeSchema,
    status: ChargeStatusSchema,
  }),

  // Stripe billing method
  z.object({
    createdTime: DateStringSchema,
    updatedTime: DateStringSchema.optional(),
    billingMethod: z.literal('stripe'),
    stripeId: BillingServiceIdSchema,
    stripePaymentMethodId: z.string(),
    unit: UnitSchema,
    amount: z.number(),
    productType: ChargeProductTypeSchema,
    status: ChargeStatusSchema,
  }),

  // Credit program billing method
  z.object({
    createdTime: DateStringSchema,
    updatedTime: DateStringSchema.optional(),
    billingMethod: z.literal('mntn_credits'),
    mntnCustomerId: MntnCustomerIdSchema,
    unit: z.literal('mntn_credits'),
    amount: z.number(),
    originalAmount: z.number(),
    productType: ChargeProductTypeSchema,
    status: ChargeStatusSchema,
  }),

  // Meta billing method
  z.object({
    createdTime: DateStringSchema,
    updatedTime: DateStringSchema.optional(),
    billingMethod: z.literal('meta'),
    unit: z.literal('meta'),
    amount: z.number(),
    productType: ChargeProductTypeSchema,
    status: ChargeStatusSchema,
  }),

  // TikTok billing method
  z.object({
    createdTime: DateStringSchema,
    updatedTime: DateStringSchema.optional(),
    billingMethod: z.literal('tiktok'),
    unit: z.literal('tiktok'),
    amount: z.number(),
    productType: ChargeProductTypeSchema,
    status: ChargeStatusSchema,
  }),

  // LinkedIn billing method
  z.object({
    createdTime: DateStringSchema,
    updatedTime: DateStringSchema.optional(),
    billingMethod: z.literal('linkedin'),
    unit: z.literal('linkedin'),
    amount: z.number(),
    productType: ChargeProductTypeSchema,
    status: ChargeStatusSchema,
  }),
])

export type ChargeLineItem = ZodSimplify<typeof ChargeLineItemSchema>
